import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useRef, useState } from "react";
import { isMobile } from "react-device-detect";
import ImageGallery from "react-image-gallery";
import { IGalleryElement } from "../../app/models/content";
import { RootStoreContext } from "../../app/stores/rootStore";
import "../../assets/scss/react-image-gallery/react-image-gallery.scss";
import ThumbnailGridScreen from "../widgets/ThumbnailGridScreen";
import BottomLeftButtonsContainer from "./BottomLeftButtonsContainer";
import CustomFullscreenButton from "./CustomFullscreenButton";
import CustomGalleryItem from "./CustomGalleryItem";
import CustomSlideArrowButton from "./CustomSlideArrowButton";
import CustomThumbnail from "./CustomThumbnail";
import { toast } from "react-toastify";

interface IParams {
  items: IGalleryElement[];
  startingPage: number;
}

const GenericTeletabberGallery: React.FC<IParams> = ({
  items,
  startingPage,
}) => {
  // MOBX STORE
  const rootStore = useContext(RootStoreContext);
  const { setGalleryPage, currentGalleryPage ,  setIsGallery} = rootStore.commonStore;
  const { isSynced, isZoomPortionEnabled , setZoomPortionEnabled,setSharedObject} = rootStore.playerStore;
  const { isZoomed, ZwibblerOverlayResize, isOneButtonEnabled ,
    zwiblerOverlayResizeZoomPortion
  } =
    rootStore.zwibblerStore;
    const {sendSharedWidget}= rootStore.tenantStore;
  // HOOKS
  const [showThumbnailsBar, setShowThumbnailsBar] = useState(true);
  const [isThumbnailGridOpen, setIsThumbnailsGridOpen] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isMultiTouch, setIsMultiTouch] = useState(false)
  const ImageGalleryRef = useRef<ImageGallery | null>(null);

  useEffect(() => {
    setIsGallery(true);
    if (startingPage > 0 && items.length > 0) {
      setGalleryPage(startingPage - 1, items.length);
    }
  }, [startingPage, setGalleryPage, items.length]);

  const handleToggleFullscreen = () => {
    if (ImageGalleryRef.current) {
      if (isFullscreen) ImageGalleryRef.current.exitFullScreen();
      else ImageGalleryRef.current.fullScreen();
    }
  };
  const process_touchstart= (ev:any) => {
    switch (ev.touches.length) {
      case 1: setIsMultiTouch(false); break;
      default: setIsMultiTouch(true); break;
    }
  }

  const handleFullscreenChange = (fs: boolean) => {
   
    if(!fs){
  
      setSharedObject();  
      sendSharedWidget(); 

    }
   setIsFullscreen(fs);
    // allows zwibbler to finish render before recalculating
    setTimeout(() => {
      ZwibblerOverlayResize();
    }, 100);
  
  };

  return (
    <>
      <div className="generic-ttgallery-container" onTouchStart={process_touchstart}>
        {/* without this the thumbnails don't change when a note is added/deleted */}
        {items.map((x) => x.hasNote)}
        <ImageGallery
          showThumbnails={showThumbnailsBar}
          // show left-right arrows
          showNav={!isMobile}
          lazyLoad={true}
          infinite={false}
          // gallery items (originalImage, thumbImage, etc)
          items={items}
          // custom fullscreen button
          renderFullscreenButton={(onClick, fs) => (
            <CustomFullscreenButton
              isFullscreen={fs}
              onZoomButtonClick={onClick}
            />
          )}
          renderItem={(item: any) => (
            <CustomGalleryItem
              itemType={item.type}
              itemUrl={item.original}
              itemIndex={item.index - 1}
              fileId={item.fileId}
              isCurrentlyVisible={currentGalleryPage === item.index - 1}
              isThumbnailsBarOpen={showThumbnailsBar}
              isFullscreen={isFullscreen}
              onDoubleClick={handleToggleFullscreen}
            />
          )}
          renderThumbInner={(item: any) => (
            <CustomThumbnail
              item={item as IGalleryElement}
              isSelected={currentGalleryPage === item.index - 1}
            />
          )}
          // starting page
          startIndex={currentGalleryPage}
          // custom buttons on the bottom left of the component
          renderPlayPauseButton={() => (
            <BottomLeftButtonsContainer
              isFullscreen={isFullscreen}
              thumbnailBarButtonClick={() =>
               { setShowThumbnailsBar(!showThumbnailsBar)
                zwiblerOverlayResizeZoomPortion();
               }
              }
              thumbnailGridButtonClick={() => {setIsThumbnailsGridOpen(true);  zwiblerOverlayResizeZoomPortion() }}
            />
          )}
          // custom right arrow
          renderRightNav={
            
            () => (
            <CustomSlideArrowButton
              direction={"right"}
              onClick={() =>
                setGalleryPage(currentGalleryPage + 1, items.length)
              }
              disabled={(isOneButtonEnabled || isZoomPortionEnabled)? true : false}
            />
          )}
          // custom left arrow
          renderLeftNav={() => (
            <CustomSlideArrowButton
              direction={"left"}
              onClick={() =>
                setGalleryPage(currentGalleryPage - 1, items.length)
              }
              disabled={(isOneButtonEnabled || isZoomPortionEnabled)? true : false}
            />
          )}
          // when swiping or clicking left/right arrows
          onSlide={(ci) => {
            setGalleryPage(ci, items.length);
          }}
          // disable swipe feature when the content was zoomed
          // disableSwipe={isZoomed || isOneButtonEnabled || isMultiTouch}
          disableSwipe={isZoomed || isOneButtonEnabled || isMultiTouch || isZoomPortionEnabled}
          onScreenChange={handleFullscreenChange}
          ref={ImageGalleryRef}
        />
      </div>
      {!isSynced && isThumbnailGridOpen && (
        <ThumbnailGridScreen
          thumbnails={items}
          selectedIndex={currentGalleryPage}
          onThumbnailClick={(index: number) => {
            setGalleryPage(index - 1, items.length);
            setIsThumbnailsGridOpen(false);
          }}
          toggle={() => setIsThumbnailsGridOpen(false)}
        />
      )}
    </>
  );
};

export default observer(GenericTeletabberGallery);
